import React from 'react'
import { Collapse } from 'antd'
import { CaretRightOutlined } from '@ant-design/icons'

import PageHeader from '../Layout/PageHeader'
import ClaimPayoutForm from '../Payout/ClaimPayoutForm'

import { PERMISSIONS } from "../../constants/roles";
import { usePermissions } from "../App/PermissionContext";

const ClaimPayout = () => {
  const { permissions } = usePermissions();

  return (
    <div>
      <PageHeader
        title="Claim Payout"
        childRoutes={[{ path: "/claim-payout", breadcrumbName: "Claim Payout" }]}
      />

      {permissions?.includes(PERMISSIONS.PAYOUT_UPLOAD) && (
        <Collapse
          expandIcon={({ isActive }) => (
            <CaretRightOutlined rotate={isActive ? 90 : 0} />
          )}
        >
          <Collapse.Panel header="New Payout" key="payout-panel">
            <ClaimPayoutForm />
          </Collapse.Panel>
        </Collapse>
      )}
    </div>
  )
}

export default ClaimPayout